import React from "react";
import "../../assets/fa-icons/css/fontawesome.css";
import "../../assets/fa-icons/css/sharp-solid.css";
import { FontStyles } from "../utils/font-styles.ts";
import { PropertyTagsDisplay } from "./property-tags-display.tsx";
import { PropertyKeyInfoList } from "./property-key-info-list.tsx";
import { usePropertyDetailsContext } from "./contexts/property-details-context.tsx";
import { PropertyHighlight } from "./property-highlight.tsx";
import { getPriceDisplay } from "./utils/price-helper.ts";

export const MainPropertyInfo: React.FC = () => {
  const { price, displayAddress, mainTitle, rental, offerType } = usePropertyDetailsContext();

  const priceDisplay = getPriceDisplay(offerType, price, rental);

  return (
    <div className={"flex flex-col tracking-normal gap-y-6 md:gap-6.5"}>
      <div className={"flex flex-col md:flex-row gap-y-3 md:justify-between md:items-center"}>
        <div className={`text-nowrap order-last md:order-first ${FontStyles.h5} leading-none font-medium`}>
          {priceDisplay}
        </div>
        <PropertyTagsDisplay className="flex gap-1.5 order-first md:order-last flex-wrap" />
      </div>
      <div className={"flex flex-col gap-y-2.5 md:gap-y-3"}>
        <h1 className={`text-north-sea text-wrap font-medium ${FontStyles.h3}`}>{mainTitle}</h1>
        <div className={`font-medium text-wrap ${FontStyles["body-l"]} leading-normal`}>{displayAddress}</div>
      </div>
      <PropertyKeyInfoList className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5 mt-3 md:mt-0" />
      <PropertyHighlight />
    </div>
  );
};
